<template>
  <div class="home-container">
    <div class="home-scroll">
      <van-nav-bar class="nav-bar" fixed placeholder>
        <template #left>
          <div class="home_app_name">
            {{ (baseInfo && baseInfo.name) || $t('index.club_name') }}
          </div>
        </template>
      </van-nav-bar>

      <div class="banner">
        <swiper
          v-if="banners.length > 0"
          ref="bannerSwiper"
          class="banner_swiper"
          :options="bannerSwiperOption"
        >
          <swiper-slide v-for="(v, key) in banners" :key="key">
            <van-image
              class="banner_img"
              fit="cover"
              :src="bannerUrl(v.url)"
            >
              <template #loading>
                <van-loading type="spinner" size="20" color="#ff7186" />
              </template>
            </van-image>
          </swiper-slide>
        </swiper>
        <div v-else class="banner-loading">
          <van-loading color="#ff7186" type="spinner" size="24" />
        </div>
      </div>

      <div class="notice-bar">
        <van-notice-bar
          class="notice-swipe"
          left-icon="bullhorn-o"
          color="#ff637a"
          background="#ffffff"
          :text="noticeText"
          scrollable
        />
        <div class="linear-gradient"></div>
      </div>

      <div class="hot-game quick-entry">
        <div class="hot-items-div">
          <van-grid :column-num="4" :border="true">
            <van-grid-item @click="goEntry('/Recharge')">
              <div class="entry-icon">
                <img class="game_item_img1" src="/img/home/duihuan.png" alt="" />
              </div>
            </van-grid-item>
            <van-grid-item @click="goEntry('/Notice')">
              <div class="entry-icon">
                <img class="game_item_img1" src="/img/home/notice.png" alt="" />
              </div>
            </van-grid-item>
            <van-grid-item @click="goEntry('/game_n')">
              <div class="entry-icon">
                <img class="game_item_img1" src="/img/home/like_active.png" alt="" />
              </div>
            </van-grid-item>
            <van-grid-item @click="goEntry('/Membership')">
              <div class="entry-icon">
                <img class="game_item_img1" src="/img/home/vip.png" alt="" />
              </div>
            </van-grid-item>
          </van-grid>
        </div>
      </div>

      <div class="hot-game" style="margin: 0; width: 100%">
        <div class="hot-title-div">
          <span>{{ $t('home.hotlist') }}</span>
          <span class="hot-more" @click="goEntry('/Choose')">{{ $t('common.more') }}</span>
        </div>
      </div>

      <div class="hot-xuanfei">
        <div class="hot-items-div">
          <ul v-if="movielist_1.length > 0">
            <li v-for="(item, index) in movielist_1" :key="index">
              <img :src="item.img_url" alt="" />
              <ul>
                <li>
                  <div>{{ $t('home.smrz') }}</div>
                  <div>{{ $t('home.videorz') }}</div>
                </li>
                <li>
                  <div
                    v-for="(tag, ti) in (item.tags_arr || []).slice(0, 3)"
                    :key="ti"
                    :class="'tag-' + (ti % 3)"
                  >
                    {{ tag }}
                  </div>
                </li>
                <li>
                  <span>{{ $t('home.rq') }}:</span>
                  <span class="movie-list-money">{{ item.renqi || 0 }}</span>
                </li>
                <li>
                  <span>
                    {{ $t('home.sg') }}:{{ item.sg || '0cm' }}
                    {{ $t('home.xw') }}: {{ item.xw || '0' }}
                  </span>
                </li>
                <li class="apply-btn" @click="profile(item.id)">
                  {{ $t('home.apply') }}
                </li>
              </ul>
            </li>
          </ul>
          <div v-else class="list-loading">
            <van-loading color="#ff7186" type="spinner" size="24" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getStoredLang } from '../../utils/lang'
import { parseServiceTags } from '../../utils/xuanfeiTags'

export default {
  data() {
    return {
      banners: [],
      basicData: {},
      movielist_1: [],
      noticeText: '',
      bannerSwiperOption: {
        effect: 'slide',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 1,
        loop: false,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        spaceBetween: 0,
      },
    }
  },
  computed: {
    ...mapState(['userInfo', 'baseInfo']),
  },
  methods: {
    mediaUrl(url) {
      if (!url) return ''
      if (/^https?:\/\//i.test(url)) return url
      const base = process.env.NODE_ENV === 'development' ? '' : 'https://d2h0m7gk9kbvfa.cloudfront.net'
      if (url.startsWith('/')) return `${base}${url}`
      return `${base}/${url}`
    },
    bannerUrl(url) {
      return this.mediaUrl(url)
    },
    goEntry(path) {
      const guestAllowed = ['/Choose', '/Membership', '/Notice', '/Video', '/List', '/Profile', '/game_n', '/Game']
      if (!localStorage.getItem('token') && !guestAllowed.includes(path)) {
        this.$router.push('/Login')
        return
      }
      this.$router.push(path)
    },
    profile(id) {
      this.$router.push({ path: '/Profile', query: { id } })
    },
    mapXuanfeiItem(item) {
      const lang = getStoredLang()
      const tags = parseServiceTags(item, lang)
      return {
        id: item.id,
        code: item.code || item.xuanfei_name || item.id,
        img_url: this.mediaUrl(item.image || item.img_url),
        xuanfei_name: item.xuanfei_name,
        sg: item.sg ? `${item.sg}cm` : item.hight ? `${item.hight}cm` : '0cm',
        xw: item.xw || item.bust || '0',
        renqi: item.renqi || item.dianzan || item.chakan || item.price || 0,
        star: item.star || 5,
        class_name: item.class_name || '',
        tags_arr: tags,
      }
    },
    getBasicConfig() {
      this.$http({ method: 'get', url: 'sys_config' })
        .then((res) => {
          if (res.code !== 200 || !res.data) return
          this.basicData = res.data
          this.noticeText =
            res.data.notice ||
            res.data.gonggao ||
            res.data.content ||
            (this.baseInfo && this.baseInfo.name) ||
            ''
          this.getBanner(this.basicData)
        })
        .catch(() => {
          this.banners = []
        })
    },
    getBanner(data) {
      const list = (data.banners || []).filter((item) => item && item.url)
      this.banners = list
      this.bannerSwiperOption = {
        ...this.bannerSwiperOption,
        loop: list.length > 1,
        autoplay:
          list.length > 1
            ? { delay: 3000, disableOnInteraction: false }
            : false,
      }
    },
    getXuanfeiData() {
      this.$http({
        method: 'get',
        url: 'xuanfeilist',
        data: { id: 'all', page: 1, limit: 20 },
      }).then((res) => {
        const payload = res.data || {}
        const list = Array.isArray(payload.data)
          ? payload.data
          : Array.isArray(payload)
            ? payload
            : []
        this.movielist_1 = list.map((item) => this.mapXuanfeiItem(item))
      })
    },
    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' })
        .then((res) => {
          if (res.code === 200) {
            this.$store.commit('setUserInfoValue', res.data)
          }
          this.getBasicConfig()
          this.getXuanfeiData()
        })
        .catch(() => {
          this.getBasicConfig()
          this.getXuanfeiData()
        })
    },
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo()
    } else {
      this.getBasicConfig()
      this.getXuanfeiData()
    }
  },
}
</script>

<style lang="less" scoped>
.home-container {
  height: 100%;
  background-color: #f2f2f2;
  padding-bottom: 16vw;
}

.home-scroll {
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: #fff;
}

.nav-bar {
  background: #fff !important;
  height: 13.333vw;
  padding: 0 1.333vw;

  /deep/ .van-nav-bar__content {
    background: #fff;
    height: 13.333vw;
  }

  /deep/ .van-hairline--bottom::after {
    border: none !important;
  }
}

.home_app_name {
  font-size: 5.867vw;
  font-weight: 600;
  color: #ff5e75;
}

.banner {
  width: 100%;
  background: #fff;
  padding: 0 0 2.667vw;
  box-sizing: border-box;
}

.banner_swiper {
  width: 100%;
  overflow: hidden;
  border-radius: 0;
}

::v-deep .banner_swiper .swiper-slide {
  width: 100%;
  height: 40vw;
  border-radius: 0;
  overflow: hidden;
  background-color: #fff;
}

::v-deep .banner_swiper .banner_img {
  border-radius: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: block;
}

::v-deep .banner_swiper .banner_img .van-image__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0;
}

.banner-loading,
.list-loading {
  height: 40vw;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notice-bar {
  position: relative;
  margin: 2vw 2.667vw 0;
  border: 1px solid #ffd0d7;
  border-radius: 1.333vw;
  overflow: hidden;
  background: #fff;
}

.notice-swipe {
  height: 11vw;
  font-size: 3.733vw;
  line-height: 11vw;
  padding: 0 3vw;
}

::v-deep .notice-swipe .van-notice-bar__left-icon {
  font-size: 5.333vw;
  min-width: 5.867vw;
}

::v-deep .notice-swipe .van-notice-bar__wrap,
::v-deep .notice-swipe .van-notice-bar__content {
  font-size: 3.733vw;
}

.linear-gradient {
  display: none;
}

.quick-entry {
  width: 100%;
  background: #fff;
  margin: 2vw 0;
  border-radius: 0;
  box-shadow: none;
  overflow: hidden;

  .hot-items-div {
    width: 100%;
    margin: 0;
  }

  ::v-deep .van-grid-item__content {
    padding: 0 !important;
    width: 100%;
    aspect-ratio: 1 / 1;
    height: auto !important;
    box-sizing: border-box;
    background: #fff;
  }
}

.entry-icon {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 34%;
}

.game_item_img1 {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.hot-game {
  width: calc(100% - 2.667vw);
  background-color: #fff;
  margin: 2.667vw 1.333vw;
}

.hot-title-div {
  height: 10.667vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 4vw);
  margin: 0 auto;

  > span {
    font-size: 4.267vw;
    color: #2c3e50;
    font-weight: 600;
  }

  .hot-more {
    font-size: 3.733vw;
    color: #ff7186;
    font-weight: 500;
    cursor: pointer;
  }
}

.hot-xuanfei {
  width: 100%;
  background-color: #fff;
  padding-bottom: 4vw;
}

.hot-items-div {
  width: calc(100% - 6.667vw);
  margin: 0 auto;

  > ul {
    display: flex;
    flex-direction: column;
  }

  > ul > li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 5.333vw;

    > img {
      width: 20vw;
      height: 20vw;
      object-fit: cover;
      border-radius: 0.8vw;
      margin-right: 2.667vw;
      flex-shrink: 0;
    }

    > ul {
      flex: 1;
      min-width: 0;

      > li {
        display: flex;
        align-items: center;
      }

      > li:first-child {
        height: 6.667vw;
        margin-bottom: 0.8vw;

        > div:first-child,
        > div:nth-child(2) {
          background: linear-gradient(180deg, #e7caaf, #fff7ed);
          color: #a4826b;
          font-weight: 600;
          padding: 0 0.8vw;
          font-size: 2.667vw;
          border-radius: 0.8vw 0 0.8vw 0;
          margin-right: 0.8vw;
        }

        > div:nth-child(3) {
          font-size: 3.2vw;
          margin-left: 2.667vw;
          color: #333;
        }
      }

      > li:nth-child(2) {
        flex-wrap: wrap;
        margin-bottom: 1.2vw;

        > div {
          color: #fff;
          font-size: 2.667vw;
          padding: 0.4vw 1.2vw;
          border-radius: 0.8vw;
          margin-right: 1.2vw;
          margin-bottom: 0.8vw;
        }

        .tag-0 {
          background: #ff7186;
        }
        .tag-1 {
          background: #ff9f43;
        }
        .tag-2 {
          background: #54a0ff;
        }
      }

      > li:nth-child(3) {
        font-size: 3.2vw;
        color: #8e4ff1;
        margin-bottom: 0.8vw;

        .movie-list-money {
          margin-left: 1vw;
          font-weight: 700;
        }
      }

      > li:nth-child(4) {
        font-size: 2.933vw;
        color: #999;
        line-height: 1.4;
        margin-bottom: 1.6vw;
      }

      .apply-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 8vw;
        background: linear-gradient(90deg, #8e4ff1, #6c5ce7);
        color: #fff !important;
        border-radius: 1.2vw;
        font-size: 3.2vw;
        font-weight: 600;
      }
    }
  }
}
</style>
